import { FC, useState } from "react";
import cn from "classnames";
import styles from "./ProcessListItem.module.sass";
import { ModalWindow } from "components/ModalWindow/ModalWindow";
import { EditionProcess } from "../EditionProcess/EditionProcess";
import { ReactComponent as BusinessProcessYes } from "images/BusinessProcessYes.svg";
import { ReactComponent as BusinessProcessNo } from "images/BusinessProcessNo.svg";
import { SettingConnection } from "../../ObjectsRegister/SettingConnection/SettingConnection";
import ConfirmNavigate from "components/ConfirmNavigate";

interface ProcessListItemProps {
	process: any;
	className: string;
}

export const ProcessListItem: FC<ProcessListItemProps> = ({ process, className }) => {
	const [modalWindow, setModalWindow] = useState<boolean>(false);
	const [connectionWindow, setConnectionWindow] = useState<boolean>(false);
	const [confirmAction, setConfirmAction] = useState<boolean>(false);
	const [action, setAction] = useState<() => void>(() => {});

	const openModalWindow = () => {
		if (process.hasRepeatable) {
			setConfirmAction(true);
			setAction(() => () => setModalWindow(true));
		} else setModalWindow(true);
	};

	const closeModalWindow = () => {
		setModalWindow(false);
	};

	const connectionClickHandler = (e: React.MouseEvent<HTMLTableCellElement>) => {
		e.stopPropagation();
		if (process.hasRepeatable) {
			setConfirmAction(true);
			setAction(() => () => setConnectionWindow(true));
		} else setConnectionWindow(true);
	};

	const confirmClick = () => {
		action();
		setConfirmAction(false);
	};

	// useEffect(() => {
	//     document.addEventListener("click", clearSelectedProcessHandler);

	//     return () => {
	//         document.removeEventListener("click", clearSelectedProcessHandler);
	//     }
	// }, [])

	return (
		// <tr className={classNames(styles.row, (process.id === selectedProcess?.id && styles.selected))} onClick={selectProcessHandler}>
		<>
			{modalWindow && (
				<ModalWindow close={closeModalWindow}>
					<EditionProcess close={closeModalWindow} process={process} />
				</ModalWindow>
			)}
			{connectionWindow && (
				<ModalWindow close={() => setConnectionWindow(false)}>
					<SettingConnection
						mode="process"
						close={() => setConnectionWindow(false)}
						targetId={process.id}
						title="Задать связь с объектом"
						subtitle="Выберите объект"
					/>
				</ModalWindow>
			)}
			<ConfirmNavigate toggle={confirmAction} close={() => setConfirmAction(false)} clickHandler={confirmClick} />
			<tr className={`${styles.row} ${className}`} onClick={openModalWindow}>
				{/* <tr className={styles.row} onClick={openModalWindow}> */}
				<td className={cn(styles.item, styles["item-activity"])}>
					{process.name}
					{/* <textarea className={styles.area} value={name} onChange={e => setName(e.target.value)}></textarea> */}
				</td>
				<td className={styles.item}>{process.shortDescription}</td>
				<td className={styles.criteria}>
					<div className={styles["criteria-wrp"]}>
						{process.social ? <BusinessProcessYes /> : <BusinessProcessNo />}
						{/* <input className={styles.checkbox} type="checkbox" /> */}
					</div>
				</td>
				<td className={styles.criteria}>
					<div className={styles["criteria-wrp"]}>
						{process.politic ? <BusinessProcessYes /> : <BusinessProcessNo />}
					</div>
				</td>
				<td className={styles.criteria}>
					<div className={styles["criteria-wrp"]}>
						{process.economic ? <BusinessProcessYes /> : <BusinessProcessNo />}
					</div>
				</td>
				<td className={styles.criteria}>
					<div className={styles["criteria-wrp"]}>
						{process.ecologic ? <BusinessProcessYes /> : <BusinessProcessNo />}
					</div>
				</td>
				<td className={styles.criteria}>
					<div className={styles["criteria-wrp"]}>
						{process.defense ? <BusinessProcessYes /> : <BusinessProcessNo />}
					</div>
				</td>
				<td className={styles.item}>{process.reason}</td>
				<td className={styles.item}>{process.criticality ? "Критический" : "Некритический"}</td>
				<td className={styles.item}>{process.sequenceNumber || "—"}</td>
				<td onClick={connectionClickHandler} className={cn(styles.item, styles.choice)}>
					{/* {!Object.keys(process.objects || {}).length &&
           "Добавить связь с объектами"} */}
					{process.objects?.length
						? process.objects.map(
								(item: any, i: number) => `${item.sequence}${i + 1 === process.objects.length ? "." : ", "}`,
						  )
						: "Добавить связь с объектами"}
				</td>
				{/* <td className={styles.item}>{ !Object.keys(process.objects).length && "Добавить связь с объектами" }</td> */}
			</tr>
		</>
	);
};
